import { useRef } from 'react';
import clsx from 'clsx';
import { forward } from '../../utils/event.js';
import { hasSelectedText } from '../../utils/selection.js';
import { selectInput } from './inputs.hooks.utils.js';
import { text } from './inputs.hooks.css.js';

/**
 * Selects the input text when clicked (i.e. pointerdown + pointerup). Only selects everything if
 * the input didn't already have a selection, so the user can still pointerdown + drag to select
 * a specific range of text. And only happens on the first click event after focus, so once the
 * input is focused you can click around to move the cursor without selecting everything.
 */
const useSelectOnClick = ({ onPointerDown: onPointerDownIn, onFocus: onFocusIn, onClick: onClickIn, className, ...props }, shared) => {
    const justFocusedRef = useRef(false);
    return {
        ...props,
        // Note: these are written in the order that the browser will fire the events
        onPointerDown(e) {
            onPointerDownIn?.(e);
            justFocusedRef.current = false;
        },
        onFocus(e) {
            onFocusIn?.(e);
            justFocusedRef.current = true;
        },
        onClick(e) {
            const justFocused = justFocusedRef.current;
            justFocusedRef.current = false;
            if (forward(e, onClickIn))
                return;
            const input = e.currentTarget;
            if (!justFocused || hasSelectedText(input)) {
                return;
            }
            selectInput(input, shared);
        },
        className: clsx(className, text),
    };
};

export { useSelectOnClick };
//# sourceMappingURL=use-select-on-click.js.map
